import TextFieldUploadedImagesContextProvider from './TextFieldUploadedImagesContextProvider';
import TextFieldExternalFilesContextProvider from './TextFieldExternalFilesContextProvider';
import FileAttachments from '@/components/FileAttachments';

const TextFieldFiles = () => (
  <TextFieldUploadedImagesContextProvider>
    <TextFieldExternalFilesContextProvider>
      <FileAttachments />
    </TextFieldExternalFilesContextProvider>
  </TextFieldUploadedImagesContextProvider>
);

export default TextFieldFiles;
